function SectionOne(){
    return (
      <section className="section transform ">
     <div className="section--bg transform--bg"></div>
     <div className="section--main transform--main flexCol">
        <h2 className="fs-heading-secondary fw-black"> Transform your brand</h2>
        <p className="section--para transform--para txt-gray-mid">We are a full-service creative agency specializing in helping brands grow fast. Engage your clients through compelling visuals that do most of the marketing for you.</p>
        <a href="#" className="section--link transform--link fw-bold">Learn More</a>
     </div>
      </section>
    )
};
export default SectionOne